const SvgArrowSlim = () => (
	<svg width="1em" height="1em" viewBox="0 0 18 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
		<path d="m16.213 7 .702-.712.722.712-.722.712L16.213 7ZM1 8a1 1 0 0 1 0-2v2ZM10.83.288l6.085 6-1.404 1.424-6.085-6L10.83.288Zm6.085 7.424-6.085 6-1.404-1.424 6.085-6 1.404 1.424ZM16.213 8H1V6h15.213v2Z" />
	</svg>
)

export default SvgArrowSlim
